import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor() { }

  getValidatorErrorMessage(validatorName: string, fieldName: string, validatorValue?: any, specialRequiredMessage?: any) {
    let config;
    if (validatorName === 'serverError') {
      config = {
        'serverError': `${validatorValue}`,
      };
    } else if (validatorName === 'filetypeError') {
      config = {
        'filetypeError': `${validatorValue}`
      };
    } else {
      config = {
        'required': `${fieldName} is required ${specialRequiredMessage ? specialRequiredMessage : ''}`,
        'whitespace': `${fieldName} cannot be only spaces`,
        'minlength': `Minimum length should be ${validatorValue.requiredLength} character`,
        'pattern': `Please enter valid ${fieldName}`,
        'maxlength': `Maximum length should be ${validatorValue.requiredLength} character`,
        'min': `${fieldName} value should not be lesser than ${validatorValue.min}`,
        'max': `${fieldName} value should not be greater than ${validatorValue.max}`,
      };
    }
    return config[validatorName];
  }

  matchPassword(account: AbstractControl) {
    const password = account.get('password').value;
    const confirmPassword = account.get('password_confirmation').value;
    if (password !== confirmPassword) {
      account.get('password_confirmation').setErrors({ filetypeError: 'Password does not match' });
    } else {
      return null;
    }
  }
  matchAccountNumber(account: AbstractControl) {
    const number = account.get('number').value;
    const confirm_number = account.get('confirm_number').value;
    if(confirm_number === null || confirm_number === ''){
      account.get('confirm_number').setErrors({ filetypeError: 'Confirm Account Number is required' });
    }else if (number !== confirm_number) {
      account.get('confirm_number').setErrors({ filetypeError: 'Account Number does not match' });
    } else {
      if(number === confirm_number){
        account.get('confirm_number').setErrors(null);
      }else{
        return null;
      }
    }
  }
  matchEmailID(account: AbstractControl) {
    const emailID = account.get('email').value;
    const confirmEmailID = account.get('email_confirmation').value;
    if(confirmEmailID === null || confirmEmailID === ''){
      account.get('email_confirmation').setErrors({ filetypeError: 'Confirm Email ID is required' });
    }else if (emailID !== confirmEmailID) {
      account.get('email_confirmation').setErrors({ filetypeError: 'Email IDs do not match' });
    } else {
      if(emailID === confirmEmailID){
        account.get('email_confirmation').setErrors(null);
      }else{
        return null;
      }
    }
  }
  checkBoxOn(checkField: AbstractControl) {
    const check = checkField.get('cb').value;
    if (check === false || check === null) {
      checkField.get('cb').setErrors({ filetypeError: 'Please accept terms and conditions' });
    } else {
      return;
    }
  }
  VIDchange(checkField: AbstractControl) {
    let vid:string = checkField.get('vid').value;
    if(vid.toString().length !== 16){
      checkField.get('vid').setErrors({ filetypeError: 'Please enter correct 16 digit VID' });
    }else{
     return
    }
  }

  aadhaarCheckBoxValidation(checkField: AbstractControl){
    const check = checkField.get('cb').value;
    if (check === false || check === null) {
      checkField.get('cb').setErrors({ filetypeError: 'Please accept terms and conditions' });
    } else {
      return;
    }

  }
  validatePassword(control: AbstractControl): ValidationErrors | null {
    let value: string = control.value || '';

    if (!value) {
      return null;
    }

    // Initialize an errors object
    const errors: ValidationErrors = {};

    // Check for minimum length
    if (value.length < 8) {
      errors.minLength = true;
    }

    // Check for uppercase characters
    let upperCaseCharacters = /[A-Z]+/g;
    if (upperCaseCharacters.test(value) === false) {
      errors.upperCase = true;
    }

    // Check for lowercase characters
    let lowerCaseCharacters = /[a-z]+/g;
    if (lowerCaseCharacters.test(value) === false) {
      errors.lowerCase = true;
    }

    // Check for number characters
    let numberCharacters = /[0-9]+/g;
    if (numberCharacters.test(value) === false) {
      errors.number = true;
    }

    // Check for special characters
    let specialCharacters = /[@$!%*?&#]+/;
    if (specialCharacters.test(value) === false) {
      errors.specialCharacter = true;
    }

    // If there are no errors, return null
    if (Object.keys(errors).length === 0) {
      return null;
    }

    // Return the errors object
    return errors;
  }
}
